import script from "./PackageCategoriesList.vue?vue&type=script&setup=true&lang=ts"
export * from "./PackageCategoriesList.vue?vue&type=script&setup=true&lang=ts"

import "./PackageCategoriesList.vue?vue&type=style&index=0&id=1253341a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1253341a"]])

export default __exports__